import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { TextField, Container, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import { countries } from "../../Countries";
import "./Traveller.css";
const TravellerInformation = ({
  flight,
  handleInputChange,
  handleInputChange1,
  handleInputChange2,
  handleExpiryDateChange,
  handleExpiryDateChange1,
  handleExpiryDateChange2,
  handleDOBChange,
  handleDOBChange1,
  handleDOBChange2,
  isinternational,
  formData,
  childData,
  infant,
  handleInputGST,
}) => {
  const formatDateToYYYYMMDD = (date) => {
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`; // Return the date in YYYY-MM-DD format for the input
  };
  console.log("flight in Traveller", flight);
  return (
    <div className="traveller_info">
      <h4>Traveller Information</h4>

      {flight && (
        <Row>
          <React.Fragment>
            {[
              ...Array(
                flight.PexFareDetails[0] && flight.PexFareDetails[0].TotPax
              ),
            ].map((_, index) => (
              <React.Fragment key={index}>
                <Col sm={12} className="passport_field">
                  <Row style={{ marginBottom: "5px" }}>
                    <Col sm={2} className="form_field_col2">
                      <div className="contact_label cus_label">
                        <Form.Label>Adults {index + 1}</Form.Label>
                      </div>
                    </Col>
                    <Col sm={10} className="form_field_col10">
                      <div className="form_field form_select_field">
                        <div className="cus_field_input cus_select_title">
                          <Form.Control
                            as="select"
                            name={`title${index}`}
                            className="title form-control commoninputreset"
                            onChange={(e) => handleInputChange(index, e)}
                            autoComplete="off"
                          >
                            <option>Title</option>
                            <option value="Mr">Mr.</option>
                            <option value="Ms">Ms.</option>
                            <option value="Mrs">Mrs.</option>
                          </Form.Control>
                        </div>
                        <div className="cus_field_input cus_name_field">
                          <Form.Label className="travellers-service-form-controll">
                            Title & First Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name={`firstName${index}`}
                            placeholder="First Name"
                            className="form-control firstname commoninputreset"
                            onChange={(e) => handleInputChange(index, e)}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="form_field">
                        <div className="cus_field_input cus_name_field">
                          <Form.Label className="travellers-service-form-controll">
                            Last Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name={`lastName${index}`}
                            placeholder="Last Name"
                            className="form-control firstname commoninputreset"
                            onChange={(e) => handleInputChange(index, e)}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="date_field">
                        <div
                          className="cus_field_input"
                          style={{ marginTop: "20px" }}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Date of Birth"
                              name={`date${index}`}
                              value={
                                formData[index]?.date
                                  ? dayjs(formData[index]?.date)
                                  : null
                              }
                              onChange={(newValue) => {
                                const syntheticEvent = {
                                  target: {
                                    name: `date${index}`,
                                    value: newValue?.format("YYYY-MM-DD") || "",
                                  },
                                };
                                handleInputChange(index, syntheticEvent);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  placeholder="Date of Birth"
                                  autoComplete="off"
                                  style={{ height: "20px", color: "#000" }}
                                  className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {isinternational && (
                    <Row>
                      <Col sm={2} className="form_field_col2">
                        <div className="contact_label cus_label">
                          <Form.Label>Passport Detail</Form.Label>
                        </div>
                      </Col>
                      <Col sm={10} className="form_field_col10 ">
                        <div className="form_field">
                          <div className="cus_field_input cus_name_field">
                            <Form.Label className="travellers-service-form-controll">
                              Passport Number
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`passport${index}`}
                              placeholder="Passport No."
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange(index, e)}
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        <div className="date_field">
                          <div
                            className="cus_field_input"
                            style={{ marginTop: "20px" }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Expiry Date"
                                name={`expirydate${index}`} // Dynamically set the name
                                value={
                                  formData[index]?.expirydate
                                    ? dayjs(
                                        formData[index]?.expirydate,
                                        "DD-MM-YYYY"
                                      )
                                    : null // Convert string to dayjs object with the correct format
                                }
                                onChange={(newValue) => {
                                  // Create a synthetic event to match handleInputChange's expected input
                                  const syntheticEvent = {
                                    target: {
                                      name: `expirydate${index}`,
                                      value:
                                        newValue?.format("DD-MM-YYYY") || "", // Format as DD-MM-YYYY
                                    },
                                  };
                                  handleInputChange(index, syntheticEvent);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    placeholder="Expiry Date"
                                    autoComplete="off"
                                    style={{ height: "auto" }}
                                    inputProps={{
                                      ...params.inputProps,
                                      min: new Date()
                                        .toISOString()
                                        .split("T")[0], // Set min to today's date
                                    }}
                                    className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                        <div className="date_field">
                          <div className="cus_field_input ">
                            <Form.Label
                              className="travellers-service-form-controll"
                              style={{ marginLeft: "10px" }}
                            >
                              Select Country
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name={`nationality${index}`}
                              className="title form-control commoninputreset selection_country_Ccode_Travell"
                              onChange={(e) => handleInputChange(index, e)}
                              autoComplete="off"
                            >
                              <option value="Nationality">Nationality</option>
                              {countries.map((country, index) => (
                                <option value={country.Code}>
                                  {country.Name}
                                </option>
                              ))}
                            </Form.Control>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </React.Fragment>
            ))}
          </React.Fragment>

          {flight.PexFareDetails[1] && (
            <React.Fragment>
              {[...Array(flight.PexFareDetails[1].TotPax)].map((_, index) => (
                <React.Fragment key={index}>
                  <Col sm={12} className="passport_field">
                    <Row style={{ marginBottom: "5px" }}>
                      <Col sm={2} className="form_field_col2">
                        <div className="contact_label cus_label">
                          <Form.Label>Child {index + 1}</Form.Label>
                        </div>
                      </Col>
                      <Col sm={10} className="form_field_col10">
                        <div className="form_field form_select_field">
                          <div className="cus_field_input cus_select_title">
                            <Form.Control
                              as="select"
                              name={`title${index}`}
                              className="title form-control commoninputreset"
                              onChange={(e) => handleInputChange1(index, e)}
                              autoComplete="off"
                            >
                              <option>Title</option>
                              <option value="Mr">Mr.</option>
                              <option value="Ms">Ms.</option>
                              <option value="Mrs">Mrs.</option>
                            </Form.Control>
                          </div>
                          <div className="cus_field_input cus_name_field">
                            <Form.Label className="travellers-service-form-controll">
                              Title & First Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`firstName${index}`}
                              placeholder="First Name"
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange1(index, e)}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="form_field">
                          <div className="cus_field_input cus_name_field">
                            <Form.Label className="travellers-service-form-controll">
                              Last Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`lastName${index}`}
                              placeholder="Last Name"
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange1(index, e)}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="date_field">
                          <div
                            className="cus_field_input"
                            style={{ marginTop: "20px" }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Date of Birth"
                                name={`date${index}`}
                                value={
                                  childData[index]?.date
                                    ? dayjs(childData[index]?.date)
                                    : null
                                }
                                onChange={(newValue) => {
                                  const syntheticEvent = {
                                    target: {
                                      name: `date${index}`,
                                      value:
                                        newValue?.format("YYYY-MM-DD") || "",
                                    },
                                  };
                                  handleInputChange1(index, syntheticEvent);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    placeholder="Date of Birth"
                                    autoComplete="off"
                                    style={{ height: "20px", color: "#000" }}
                                    className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {isinternational && (
                      <Row>
                        <Col sm={2} className="form_field_col2">
                          <div className="contact_label cus_label">
                            <Form.Label>Passport Detail</Form.Label>
                          </div>
                        </Col>
                        <Col sm={10} className="form_field_col10 ">
                          <div className="form_field">
                            <div className="cus_field_input cus_name_field">
                              <Form.Label className="travellers-service-form-controll">
                                Passport Number
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name={`passport${index}`}
                                placeholder="Passport No."
                                className="form-control firstname commoninputreset"
                                onChange={(e) => handleInputChange1(index, e)}
                                autoComplete="off"
                              />
                            </div>
                          </div>

                          <div className="date_field">
                            <div
                              className="cus_field_input"
                              style={{ marginTop: "20px" }}
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Expiry Date"
                                  name={`expirydate${index}`} // Dynamically set the name
                                  value={
                                    childData[index]?.expirydate
                                      ? dayjs(
                                          childData[index]?.expirydate,
                                          "DD-MM-YYYY"
                                        )
                                      : null // Convert string to dayjs object with the correct format
                                  }
                                  onChange={(newValue) => {
                                    // Create a synthetic event to match handleInputChange's expected input
                                    const syntheticEvent = {
                                      target: {
                                        name: `expirydate${index}`,
                                        value:
                                          newValue?.format("DD-MM-YYYY") || "", // Format as DD-MM-YYYY
                                      },
                                    };
                                    handleInputChange1(index, syntheticEvent);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      placeholder="Expiry Date"
                                      autoComplete="off"
                                      style={{ height: "auto" }}
                                      inputProps={{
                                        ...params.inputProps,
                                        min: new Date()
                                          .toISOString()
                                          .split("T")[0], // Set min to today's date
                                      }}
                                      className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            </div>
                          </div>
                          <div className="date_field">
                            <div className="cus_field_input ">
                              <Form.Label
                                className="travellers-service-form-controll"
                                style={{ marginLeft: "10px" }}
                              >
                                Select Country
                              </Form.Label>
                              <Form.Control
                                as="select"
                                name={`nationality${index}`}
                                className="title form-control commoninputreset selection_country_Ccode_Travell"
                                onChange={(e) => handleInputChange1(index, e)}
                                autoComplete="off"
                              >
                                <option value="Nationality">Nationality</option>
                                {countries.map((country, index) => (
                                  <option value={country.Code}>
                                    {country.Name}
                                  </option>
                                ))}
                              </Form.Control>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </React.Fragment>
              ))}
            </React.Fragment>
          )}

          {flight.PexFareDetails[2] && (
            <React.Fragment>
              {[...Array(flight.PexFareDetails[2].TotPax)].map((_, index) => (
                <React.Fragment key={index}>
                  <Col sm={12} className="passport_field">
                    <Row style={{ marginBottom: "5px" }}>
                      <Col sm={2} className="form_field_col2">
                        <div className="contact_label cus_label">
                          <Form.Label>Infant {index + 1}</Form.Label>
                        </div>
                      </Col>
                      <Col sm={10} className="form_field_col10">
                        <div className="form_field form_select_field">
                          <div className="cus_field_input cus_select_title">
                            <Form.Control
                              as="select"
                              name={`title${index}`}
                              className="title form-control commoninputreset"
                              onChange={(e) => handleInputChange2(index, e)}
                              autoComplete="off"
                            >
                              <option>Title</option>
                              <option value="Mr">Mr.</option>
                              <option value="Ms">Ms.</option>
                              <option value="Mrs">Mrs.</option>
                            </Form.Control>
                          </div>
                          <div className="cus_field_input cus_name_field">
                            <Form.Label className="travellers-service-form-controll">
                              Title & First Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`firstName${index}`}
                              placeholder="First Name"
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange2(index, e)}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="form_field">
                          <div className="cus_field_input cus_name_field">
                            <Form.Label className="travellers-service-form-controll">
                              Last Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`lastName${index}`}
                              placeholder="Last Name"
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange2(index, e)}
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        <div className="date_field">
                          <div
                            className="cus_field_input"
                            style={{ marginTop: "20px" }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Date of Birth"
                                name={`date${index}`}
                                value={
                                  infant[index]?.date
                                    ? dayjs(infant[index]?.date)
                                    : null
                                }
                                onChange={(newValue) => {
                                  const syntheticEvent = {
                                    target: {
                                      name: `date${index}`,
                                      value:
                                        newValue?.format("YYYY-MM-DD") || "",
                                    },
                                  };
                                  handleInputChange2(index, syntheticEvent);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    placeholder="Date of Birth"
                                    autoComplete="off"
                                    style={{ height: "20px", color: "#000" }}
                                    className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {isinternational && (
                      <Row>
                        <Col sm={2} className="form_field_col2">
                          <div className="contact_label cus_label">
                            <Form.Label>Passport Detail</Form.Label>
                          </div>
                        </Col>
                        <Col sm={10} className="form_field_col10 ">
                          <div className="form_field">
                            <div className="cus_field_input cus_name_field">
                              <Form.Label className="travellers-service-form-controll">
                                Passport Number
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name={`passport${index}`}
                                placeholder="Passport No."
                                className="form-control firstname commoninputreset"
                                onChange={(e) => handleInputChange2(index, e)}
                                autoComplete="off"
                              />
                            </div>
                          </div>

                          <div className="date_field">
                            <div
                              className="cus_field_input"
                              style={{ marginTop: "20px" }}
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Expiry Date"
                                  name={`expirydate${index}`} // Dynamically set the name
                                  value={
                                    infant[index]?.expirydate
                                      ? dayjs(
                                          infant[index]?.expirydate,
                                          "DD-MM-YYYY"
                                        )
                                      : null // Convert string to dayjs object with the correct format
                                  }
                                  onChange={(newValue) => {
                                    // Create a synthetic event to match handleInputChange's expected input
                                    const syntheticEvent = {
                                      target: {
                                        name: `expirydate${index}`,
                                        value:
                                          newValue?.format("DD-MM-YYYY") || "", // Format as DD-MM-YYYY
                                      },
                                    };
                                    handleInputChange2(index, syntheticEvent);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      placeholder="Expiry Date"
                                      autoComplete="off"
                                      style={{ height: "auto" }}
                                      inputProps={{
                                        ...params.inputProps,
                                        min: new Date()
                                          .toISOString()
                                          .split("T")[0], // Set min to today's date
                                      }}
                                      className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            </div>
                          </div>
                          <div className="date_field">
                            <div className="cus_field_input ">
                              <Form.Label
                                className="travellers-service-form-controll"
                                style={{ marginLeft: "10px" }}
                              >
                                Select Country
                              </Form.Label>
                              <Form.Control
                                as="select"
                                name={`nationality${index}`}
                                className="title form-control commoninputreset selection_country_Ccode_Travell"
                                onChange={(e) => handleInputChange2(index, e)}
                                autoComplete="off"
                              >
                                <option value="Nationality">Nationality</option>
                                {countries.map((country, index) => (
                                  <option value={country.Code}>
                                    {country.Name}
                                  </option>
                                ))}
                              </Form.Control>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </React.Fragment>
              ))}
            </React.Fragment>
          )}
        </Row>
      )}
      <div
        className="alert-wrapper makeFlex appendBottom12 appendTop12 travellerSectionAlert"
        style={{
          backgroundImage:
            "linear-gradient(90deg, rgb(156 87 241) 20%, rgb(200 151 243) 40%, rgb(219 208 255) 90%)",
          color: "#fff",
        }}
      >
        <div className="makeFlex flexOne column">
          <p className="darkText fontSize12 boldFont">
            <span className="alert-text">
              <b>Important: </b>Please ensure that the names of the passengers
              on the travel documents are the same as on their government-issued
              identity proof.
              <br />
            </span>
          </p>
        </div>
      </div>
    </div>
    // <div>
    //   <div className="theme-box-shadow theme-border-radius bg-light mb-3 p-3">
    //     <div className="d-flex align-items-between mb-3">
    //       <div className="flex-grow-1">
    //         <span className="fw-bold text-uppercase">Adult</span>
    //       </div>
    //     </div>
    //     <div className="col-12 border-bottom">

    //       <div className="theme-box-shadow theme-border-radius bg-light mb-3">
    //         <div className="row border-bottom py-2 m-auto">
    //           <div className="col-8">
    //             <div className="fw-bold font-medium">Adult 1</div>
    //           </div>
    //           <div className="col-4 text-end align-self-center">
    //             <a
    //               className="font-small"
    //               data-bs-toggle="collapse"
    //               href="#collapseAdult"
    //               role="button"
    //               aria-expanded="false"
    //               aria-controls="collapseAdult"
    //             >
    //               <i className="bi bi-chevron-down ps-1" />
    //             </a>
    //           </div>
    //         </div>
    //         <div className="" id="collapseAdult">
    //           <div className="row">
    //             <div className="col-sm-12">
    //               <div className="px-3">
    //                 <ul className="row py-3">
    //                   <li className="col-12 col-md-2 pb-3">
    //                     <label
    //                       className="visually-hidden"
    //                       htmlFor="inlineFormSelectTitle"
    //                     >
    //                       Preference
    //                     </label>
    //                     <select
    //                       className="form-select"
    //                       id="inlineFormSelectTitle"
    //                     >
    //                       <option selected="">Title</option>
    //                       <option value={1}>Mr.</option>
    //                       <option value={2}>Mrs.</option>
    //                       <option value={3}>Ms.</option>
    //                     </select>
    //                   </li>
    //                   <li className="col-12 col-md-3 pb-3">
    //                     <label
    //                       className="visually-hidden"
    //                       htmlFor="specificSizeInputFirstName"
    //                     >
    //                       First Name
    //                     </label>
    //                     <input
    //                       type="text"
    //                       className="form-control"
    //                       id="specificSizeInputFirstName"
    //                       placeholder="First Name"
    //                     />
    //                   </li>
    //                   <li className="col-12 col-md-3 pb-3">
    //                     <label
    //                       className="visually-hidden"
    //                       htmlFor="specificSizeInputLastName2"
    //                     >
    //                       Last Name
    //                     </label>
    //                     <input
    //                       type="text"
    //                       className="form-control"
    //                       id="specificSizeInputLastName2"
    //                       placeholder="Last Name"
    //                     />
    //                   </li>
    //                   <li className="col-12 col-md-4 pb-3">
    //                     <label htmlFor="inlineFormSelectTitle3">
    //                       Date of Birth
    //                     </label>
    //                     <div className="row g-0 border">
    //                       <div className="col">
    //                         <select
    //                           className="form-select border-0"
    //                           id="inlineFormSelectTitle3"
    //                         >
    //                           <option selected="">Date</option>
    //                           <option value={1}>Mr.</option>
    //                           <option value={2}>Mrs.</option>
    //                           <option value={3}>Ms.</option>
    //                         </select>
    //                       </div>
    //                       <div className="col">
    //                         <select
    //                           className="form-select border-0"
    //                           id="inlineFormSelectTitle4"
    //                         >
    //                           <option selected="">Month</option>
    //                           <option value={1}>Mr.</option>
    //                           <option value={2}>Mrs.</option>
    //                           <option value={3}>Ms.</option>
    //                         </select>
    //                       </div>
    //                       <div className="col">
    //                         <select
    //                           className="form-select border-0"
    //                           id="inlineFormSelectTitle15"
    //                         >
    //                           <option selected="">Year</option>
    //                           <option value={1}>Mr.</option>
    //                           <option value={2}>Mrs.</option>
    //                           <option value={3}>Ms.</option>
    //                         </select>
    //                       </div>
    //                     </div>
    //                   </li>
    //                   <li className="col-12 col-md-12 pb-3">
    //                     <label>Passport Details*</label>
    //                     <div className="row">
    //                       <div className="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
    //                         <label
    //                           className="visually-hidden"
    //                           htmlFor="specificSizeInputPassportNumber"
    //                         >
    //                           Passport Number
    //                         </label>
    //                         <input
    //                           type="text"
    //                           className="form-control"
    //                           id="specificSizeInputPassportNumber"
    //                           placeholder="Passport Number"
    //                         />
    //                       </div>
    //                       <div className="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
    //                         <label
    //                           className="visually-hidden"
    //                           htmlFor="inlineFormSelectNationality3"
    //                         >
    //                           Nationality
    //                         </label>
    //                         <select
    //                           className="form-select"
    //                           id="inlineFormSelectNationality3"
    //                         >
    //                           <option selected="">Nationality</option>
    //                           <option value={1}>Indian</option>
    //                           <option value={2}>German</option>
    //                           <option value={3}>American</option>
    //                         </select>
    //                       </div>
    //                       <div className="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
    //                         <label
    //                           className="visually-hidden"
    //                           htmlFor="inlineFormSelectIssuedCountry"
    //                         >
    //                           Issued Country
    //                         </label>
    //                         <select
    //                           className="form-select"
    //                           id="inlineFormSelectIssuedCountry"
    //                         >
    //                           <option selected="">Issued Country</option>
    //                           <option value={1}>India</option>
    //                           <option value={2}>German</option>
    //                           <option value={3}>America</option>
    //                         </select>
    //                       </div>
    //                       <div className="col-12 col-sm-6 col-md-3 mb-3 mb-md-0">
    //                         <label
    //                           className="visually-hidden"
    //                           htmlFor="specificSizeInputExpairyDate2"
    //                         >
    //                           ExpairyDate
    //                         </label>
    //                         <input
    //                           type="text"
    //                           className="form-control"
    //                           id="specificSizeInputExpairyDate2"
    //                           placeholder="Expairy Date"
    //                         />
    //                       </div>
    //                     </div>
    //                   </li>
    //                   <li>
    //                     <span className="font-small">
    //                       Note: Please make sure that traveller's Names are as
    //                       per govt. approved Identity Card or Passport.
    //                     </span>
    //                   </li>
    //                 </ul>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>

    //     </div>
    //   </div>
    // </div>
  );
};

export default TravellerInformation;
